export default {
  data() {
    return {
      this1: this,
      collapseActiveNames: ["8"],
      borderStyleList: [
        {
          value: "solid",
          title: "实线",
          bigScreenSrc: require("assets/images/solid-1.png"),
          stageSrc: require("assets/images/solid-2.png"),
          appStageSrc: require("assets/images/solid-2.png")
        },
        {
          value: "dashed",
          title: "虚线",
          bigScreenSrc: require("assets/images/dashed-1.png"),
          stageSrc: require("assets/images/dashed-2.png"),
          appStageSrc: require("assets/images/dashed-2.png")
        },
        {
          value: "dotted",
          title: "点线",
          bigScreenSrc: require("assets/images/dotted-1.png"),
          stageSrc: require("assets/images/dotted-2.png"),
          appStageSrc: require("assets/images/dotted-2.png")
        }
      ],
      fontFamilyList: [
        {
          label: "默认字体",
          value: "sans-serif"
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体"
        },
        {
          label: "方正",
          value: "方正"
        },
        {
          label: "方正正大黑简体",
          value: "方正正大黑简体"
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体"
        },
        {
          label: "庞门正道标题",
          value: "庞门正道标题"
        },
        {
          label: "思源黑体",
          value: "SourceHanSansCN"
        },
        {
          label: "思源宋体",
          value: "SourceHanSerifCN"
        },
        {
          label: "优设标题黑",
          value: "YouSheBiaoTiHei"
        },
        {
          label: "Alata",
          value: "Alata"
        },
        {
          label: "D-din",
          value: "D-din"
        },
        {
          label: "D-din Condensed",
          value: "D-din Condensed"
        },
        {
          label: "D-din Exp",
          value: "D-din Exp"
        },
        {
          label: "Raleway",
          value: "Raleway"
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular"
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black"
        }
      ],
      positionList1: [
        {
          title: "上",
          label: "top"
        },
        {
          title: "下",
          label: "bottom"
        },
        {
          title: "中",
          label: "middle"
        }
      ],
      positionList2: [
        {
          title: "居左",
          label: "left"
        },
        {
          title: "居中",
          label: "center"
        },
        {
          title: "居右",
          label: "right"
        }
      ],
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 600
        },
        {
          title: "加粗体",
          value: 900
        }
      ],
      animateDurTime: 1,
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ]
    }
  }
}
